import * as React from "react";
import { Button } from "@octopusdeploy/design-system-components";
import BusyFromPromise from "components/BusyFromPromise";

export interface ActionButtonProps {
    innerRef?: any;
    label: string;
    busyLabel?: string;
    disabled?: Promise<any> | boolean;
    type?: ActionButtonType;
    icon?: JSX.Element;
    iconPosition?: IconPosition;
    tabIndex?: number;
    className?: string;
    keyboardFocused?: boolean;
    style?: object;
    labelProps?: any;
    children?: React.ReactNode;

    onFocus?(event: React.FocusEvent<HTMLElement>): void;
    onClick?(event: any): Promise<any> | void;
}

interface ActionButtonState {
    invocation?: Promise<any>;
}

export enum ActionButtonType {
    Primary,
    Secondary,
    Ternary,
    Save,
    Delete,
    CreateRelease,
    Category,
    Ghost,
}

export enum IconPosition {
    Left,
    Right
}

type ButtonImportance = "primary" | "secondary" | "tertiary" | "destructive" | "quiet" | "loud" | "neutral" | "ghost";

function toImportance(type: ActionButtonType | undefined): ButtonImportance {
    switch (type) {
        case ActionButtonType.Primary:       return "loud";
        case ActionButtonType.Save:          return "loud";
        case ActionButtonType.CreateRelease: return "loud";
        case ActionButtonType.Delete:        return "destructive";
        case ActionButtonType.Ternary:       return "tertiary";
        case ActionButtonType.Category:      return "secondary";
        case ActionButtonType.Ghost:         return "ghost";
        default:                             return "secondary";
    }
}

export default class ActionButton extends React.Component<ActionButtonProps, ActionButtonState> {
    constructor(props: ActionButtonProps) {
        super(props);
        this.state = {};
    }

    onClick(event: React.MouseEvent) {
        if (!this.props.onClick) {
            return;
        }

        if (event.preventDefault) {
            event.preventDefault();
        }
        const promise = (async () => await this.props.onClick(event))();
        this.setState({ invocation: promise });
        return promise;
    }

    getButton(busy: boolean, disabled: boolean) {
        const label = busy && this.props.busyLabel ? this.props.busyLabel : this.props.label;
        const importance = toImportance(this.props.type);

        return (
            <Button
                label={label}
                importance={importance}
                onClick={(e) => this.onClick(e)}
                disabled={disabled}
                icon={this.props.icon}
            />
        );
    }

    render() {
        return (
            <BusyFromPromise promise={this.state.invocation}>
                {(busy: boolean) => (
                    <BusyFromPromise promise={this.props.disabled}>
                        {(disabled: boolean) => this.getButton(busy, disabled || busy)}
                    </BusyFromPromise>
                )}
            </BusyFromPromise>
        );
    }
}

export { ActionButton };
